"use strict";

var slickOption = {
  bannerL: {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true
  },
  banner: {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    slidesToShow: 6,
    responsive: [{
      breakpoint: 960,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: 'unslick'
    }]
  },
  list: {
    slidesToShow: 5,
    swipe: false,
    prevArrow: '<div class="slick-prev"><button type="button" class="slick-prev-btn"></button></div>',
    nextArrow: '<div class="slick-next"><button type="button" class="slick-next-btn"></button></div>',
    responsive: [{
      breakpoint: 960,
      settings: {
        slidesToShow: 4,
        swipe: true
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        swipe: true
      }
    }]
  },
  store_banner: {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true
  }
};
var exStores = ['らしんばんオンライン', 'らしんばんソウル弘大店', 'らしんばん台北西門店', 'らしんばん香港UNY楽富店', 'らしんばん香港旺角買取センター', 'らしんばん香港旺角T.O.P店', 'らしんばん釜山店', 'らしんばんシンガポール店'];

var initSlick = function initSlick(id) {
  if ($('[data-slick="' + id + '"]').length) {
    $('[data-slick="' + id + '"]').each(function (i, elm) {
      if (!$(elm).hasClass('slick-slider')) {
        $(elm).slick(slickOption[id]);
      }
    });
  }

  $(window).on('resize orientationchange', function () {
    $('[data-slick="' + id + '"]').slick('resize');
  });
};

var initGallary = function initGallary() {
  $('[data-gallery]').each(function (i, elm) {
    var imgLength = $(elm).children('li').length;
    var img = $(elm).addClass('gallery_list').children('li').eq(0).addClass('active').children('img').attr('src');
    var html = "<div class=\"gallery\">\n  <div class=\"gallery_image\"><img src=\"".concat(img, "\" alt=\"\"></div>\n  ").concat(imgLength > 1 ? $(elm)[0].outerHTML : '', "\n</div>");
    var $html = $(html);
    $html.find('.gallery_list').css('display', 'block').children('li').on('click', function (e) {
      var $this = $(e.currentTarget);
      if ($this.hasClass('active')) return;
      $this.siblings('li').removeClass('active');
      var img = $this.addClass('active').children('img').attr('src');
      $html.find('.gallery_image > img').attr('src', img);
    });
    $(elm).replaceWith($html);
  });
};

var initFloorModal = function initFloorModal() {
  $('.floor_slider li > a').on('click', function (e) {
    e.preventDefault();
    var index = $(e.currentTarget).attr('data-floor-index');
    $('.floor_modal_content > img').hide().eq(index).show();
    $('.floor_modal').fadeIn(200);
  });
  $('.floor_modal_close, .floor_modal_overlay').on('click', function () {
    $('.floor_modal').fadeOut(200);
  });
};

var grCallback = function grCallback() {
  $('[data-toggleRecaptcha]').prop('disabled', false);
};

var grExpiredCallback = function grExpiredCallback() {
  $('[data-toggleRecaptcha]').prop('disabled', true);
};

var isApp = function isApp() {
  var ua = navigator.userAgent ? navigator.userAgent : '';
  return ua.match(/Lashinbang_app/) !== null || ua.match(/Yappli/) !== null;
};

$(function () {
  //svgの読み込み
  $.ajax({
    url: templateDirectoryUri + '/img/svg.html',
    method: 'GET',
    dataType: 'html'
  }).done(function (response) {
    $('body').append(response);
  }); // SPメニュー

  $('#header_menuBtn').on('click', function () {
    $('.header').toggleClass('open');
    $('#header_nav').stop().slideToggle(300);
  }); // アンカーリンクのスムーズスクロール

  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();
    var href = $(e.currentTarget).attr('href');
    var target = $(href === '#' ? 'html' : href.match(/#.*$/)[0]);

    if (target.length) {
      $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 500);
    }
  }); // アコーディオン

  $('[data-accordion-btn]').on('click', function (e) {
    var id = $(e.currentTarget).attr('data-accordion-btn');
    $('[data-accordion-btn="' + id + '"], [data-accordion-content="' + id + '"]').toggleClass('open');
    $('[data-accordion-content="' + id + '"]').stop().slideToggle(300);
  }); // タブ

  $('[data-tab-btn]').on('click', function (e) {
    var id = $(e.currentTarget).attr('data-tab-btn');
    var i = $('[data-tab-btn="' + id + '"]').index(e.currentTarget);
    $('[data-tab-btn="' + id + '"], [data-tab-content="' + id + '"]').removeClass('active');
    $('[data-tab-btn="' + id + '"]').eq(i).addClass('active');
    $('[data-tab-content="' + id + '"]').eq(i).addClass('active');
  }); // セレクトボックス

  $('[data-select]').on('change', function (e) {
    var $this = $(e.currentTarget);
    var id = $this.attr('data-select');
    var text = $this.children('option:selected').text();
    $('[data-select-text="' + id + '"]').text(text);
  }); // スライダー

  Object.keys(slickOption).forEach(function (id) {
    initSlick(id);
  }); // 画像ギャラリー

  initGallary(); // モーダル

  $('[data-modal-close]').on('click', function (e) {
    $(e.currentTarget).closest('.modal').fadeOut(200);
  }); // 選択したエリアをクッキーに保存

  $('#areaSearch').on('change', function (e) {
    var value = $(e.currentTarget).val();

    if (!value.match(/[^0-9]/)) {
      document.cookie = 'lashinbang_area=' + value + '; max-age=604800; path=/';
    }
  }); // 一意のチェックボックス

  $('[data-unique]').on('change', function (e) {
    var $this = $(e.currentTarget);
    if ($this.prop('checked') === false) return false;
    $('[data-unique][name="' + $this.attr('name') + '"]').not($this).prop('checked', false);
  }); // サブミット

  $('[data-submit]').on('change', function (e) {
    $(e.currentTarget).closest('form').submit();
  }); // ブラウザバック

  $('[data-back]').on('click', function () {
    history.back(-1);
    return false;
  }); // 年齢確認

  $('[data-age-agree]').on('click', function () {
    document.cookie = 'lashinbang_r18=1; max-age=604800; path=/';
  }); // 海外からのアクセスの誘導

  $('[data-overseas-agree]').on('click', function (e) {
    document.cookie = 'lashinbang_overseas=1; path=/';
    var href = $(e.currentTarget).attr('data-overseas-href');

    if (href) {
      window.location.href = href;
    }
  }); // お問い合わせの制御

  var formSwitch = function formSwitch(type) {
    $('[data-formType]').hide().find('input, textarea, select').prop('disabled', true);
    $('[data-formType="' + type + '"]').show().find('input, textarea, select').prop('disabled', false);

    if (type > 0) {
      $('[data-formTtl]').show();
    } else {
      $('[data-formTtl]').hide();
    }

    if ($('[data-formType="' + type + '"] [data-formContent]').length) {
      var content = $('[data-formType="' + type + '"] [name="お問い合わせ内容"], [data-formType="' + type + '"] [name="お問い合わせ内容_1"]').filter(':checked').closest('li').index();
      formChildrenSwitch(type, content);
    }
  };

  var formChildrenSwitch = function formChildrenSwitch(type, content) {
    $('[data-formType="' + type + '"] [data-formContent]').hide().find('input, textarea, select').not('[name="お問い合わせ内容"], [name="お問い合わせ内容_1"]').prop('disabled', true);
    $('[data-formType="' + type + '"] [data-formContent~="' + content + '"]').show().find('input, textarea, select').prop('disabled', false);
  };

  $('[name="お問い合わせ種別"]').on('change', function (e) {
    var type = $(e.currentTarget).children(':selected').index();
    formSwitch(type);
  });
  $('[name="お問い合わせ内容"], [name="お問い合わせ内容_1"]').on('change', function (e) {
    var type = $('[name="お問い合わせ種別"]').children(':selected').index();
    var content = $(e.currentTarget).filter(':checked').closest('li').index();
    formChildrenSwitch(type, content);
  }); // フォーム file

  $('[data-file]').on('change', function (e) {
    var id = $(e.currentTarget).attr('data-file');
    var $img = $('[data-img="' + id + '"]');
    var $delete = $('[data-delete="' + id + '"]');
    var img = ['image/jpeg', 'image/png', 'image/gif'];
    $img.hide().find('img').attr('src', '');
    $delete.hide();
    if (!e.target.files.length) return false;
    $delete.show();
    if (img.indexOf(e.target.files[0].type) === -1) return false;
    var reader = new FileReader();

    reader.onload = function (e) {
      $img.show().find('img').attr('src', e.target.result);
    };

    reader.readAsDataURL(e.target.files[0]);
  }).trigger('change');
  $('[data-delete]').on('click', function (e) {
    var id = $(e.currentTarget).attr('data-delete');
    var $file = $('[data-file="' + id + '"]');
    var $img = $('[data-img="' + id + '"]');
    var $delete = $('[data-delete="' + id + '"]');
    $img.hide().find('img').attr('src', '');
    $delete.hide();
    $file.val('');
  }); // フォーム stores

  if ($('[data-formStores]').length) {
    var value = $('[data-formStores]').attr('data-formValue');
    $.ajax({
      url: apiUrl + '/api/get_store',
      method: 'GET',
      dataType: 'json'
    }).then(function (response) {
      var stores = response.items.map(function (store) {
        return store.name;
      }).filter(function (store) {
        return exStores.indexOf(store) === -1;
      });
      stores.push('その他');
      var html = '';
      stores.forEach(function (store) {
        html += '<option value="' + store + '">' + store + '</option>';
      });
      $('[data-formStores]').append(html);
      $('[data-formStores]:not(disabled) option[value="' + value + '"]').prop('selected', true);
    });
  } // yotpo


  if ($('[data-yotpo]').length) {
    (function e() {
      var e = document.createElement('script');
      e.type = 'text/javascript', e.async = true, e.src = '//staticw2.yotpo.com/ZEMhsqg7HDqoE4tm4NlV1CDSPbhjSy0pfQaAHUY3/widget.js';
      var t = document.getElementsByTagName('script')[0];
      t.parentNode.insertBefore(e, t);
    })();
  } // アプリログインに関するお問い合わせ


  if ($('body#input.appcontact').length) {
    $('input[name="4のメールアドレスと同じ"]').on('change', function (e) {
      var isCheck = $(e.currentTarget).prop('checked');
      $('input[name="ログインアカウント_メールアドレス"]').prop('disabled', isCheck);
    });
  } // ローディング


  $('.loading.dom').addClass('ready'); // Yappli ヘッダーロゴの非表示

  if (isApp()) {
    $('.header .header_logo > a').remove();
  } // クッキー同意


  $(function () {
    var $cookieNotice = $('.cookieNotice');
    var $cookieNoticeBtn = $cookieNotice.find('.cookieNotice_btn');
    if (!$cookieNotice.length || !$cookieNoticeBtn.length) return;
    var cookie = [];

    if (document.cookie !== '') {
      var tmp = document.cookie.split('; ');

      for (var i = 0; i < tmp.length; i++) {
        var data = tmp[i].split('=');
        cookie[data[0]] = decodeURIComponent(data[1]);
      }
    }

    if (cookie['cookie_ckeck'] !== 'ok') {
      $cookieNotice.addClass('show');
    } else {
      document.cookie = 'cookie_ckeck=ok;max-age=31536000;path=/';
    }

    $cookieNoticeBtn.on('click', function () {
      $cookieNotice.removeClass('show');
      document.cookie = 'cookie_ckeck=ok;max-age=31536000;path=/';
    });
  });
});